import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import userForm from "./forms/userForm";
import userList from "./lists/userList";
import classNames from "classnames";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import MembercardEditor from "./MembercardEditor";
import ModalEditor from "./ModalEditor";

class userEditor extends React.Component {

    render() {
        const UserForm = userForm;
        const UserList = userList;
        const sortable = true;
        const filterable = true;
        return (
            <Fragment>
                <Box
                    theme="default"
                >
                    <UserList {...this.props} />
                </Box>
                <Box
                    theme="default"
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.props.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={this.props.isLoading} color="default" className="pull-left" onClick={ this.props.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <UserForm {...this.props} />
                </Box>
                {this.props.values[this.props.componentConfig.idfield] && <MembercardEditor
                    editorContext="userMembercardEditor"
                    gridid="userMembercardList"
                    editor={ModalEditor}
                    pageSize={0}
                    listFilter={[
                        {field: "user", value: this.props.values[this.props.componentConfig.idfield]}
                    ]}
                />}
            </Fragment>
        );
    }
}
export default createEditor({componentName: "user", WrappedComponent: userEditor, props: {view: "admin"}});

